import { searchAllergens } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type {
  AllergySearchPagedListResponseT,
  SearchAllergensParams,
} from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export async function fetchSearchAllergens(
  params: SearchAllergensParams,
  signal?: AbortSignal
): Promise<AllergySearchPagedListResponseT> {
  const config = await createLotusRequestConfig({ signal });
  const response = await searchAllergens(params, config);
  return lotusHealthZod.searchAllergensResponse.parse(
    response.data
  ) as AllergySearchPagedListResponseT;
}
